/**
 * Destinos del bot de Transporte (2026-10-07): lista cerrada por sede (Ica /
 * Pisco) y con orden. El bot los ofrece como menú numerado en ese orden; quien
 * pide ya no escribe el destino a mano.
 */
import {
  rec_Bo as claseTarjeta,
  rec_EstadoError as EstadoError,
  rec_Lo as claseEntrada,
  rec_React as React,
  rec_api as api,
  rec_zo as claseBoton,
} from "../../runtime/index.jsx";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useEffect = (...a) => React.useEffect(...a);
const useState = (...a) => React.useState(...a);

function Fila({ inicial, sedes, onGuardado, onCancelar }) {
  const [d, setD] = useState({ nombre: ``, sede: sedes[0] ?? `ICA`, ruta: ``, orden: ``, activo: true, ...inicial });
  const [error, setError] = useState(``);
  const guardar = async (e) => {
    e.preventDefault();
    setError(``);
    try {
      await api(`/transporte/destinos`, { method: `POST`, body: JSON.stringify({ ...d, orden: d.orden === `` ? 0 : Number(d.orden) }) });
      onGuardado();
    } catch (x) {
      setError(x.message);
    }
  };
  return (
    <form onSubmit={guardar} className="flex flex-wrap items-center gap-2">
      <input className={`${claseEntrada} w-20`} type="number" min="0" placeholder="Orden" value={d.orden} onChange={(e) => setD({ ...d, orden: e.target.value })} />
      <input className={`${claseEntrada} min-w-48 flex-1`} placeholder="PARCONA" value={d.nombre} onChange={(e) => setD({ ...d, nombre: e.target.value.toUpperCase() })} required autoFocus />
      <input className={`${claseEntrada} w-40`} placeholder="Ruta a Ica" list="rutas-destinos" value={d.ruta ?? ``} onChange={(e) => setD({ ...d, ruta: e.target.value })} />
      <select className={`${claseEntrada} w-32`} value={d.sede} onChange={(e) => setD({ ...d, sede: e.target.value })}>
        {sedes.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <button type="submit" className={claseBoton}>Guardar</button>
      <button type="button" className="text-sm text-(--text)" onClick={onCancelar}>Cancelar</button>
      {error && <p className="w-full text-sm text-(--error)">{error}</p>}
    </form>
  );
}

export function DestinosMovilidad() {
  const [lista, setLista] = useState(null);
  const [sedes, setSedes] = useState([`ICA`]);
  const [editando, setEditando] = useState(null);
  const [error, setError] = useState(``);

  const cargar = () => api(`/transporte/destinos`, { sinCache: true }).then(setLista).catch((e) => setError(e.message));
  useEffect(() => {
    cargar();
    api(`/sedes`).then((l) => {
      const nombres = (l ?? []).filter((s) => s.activo).map((s) => s.nombre.toUpperCase()).filter((n) => n !== `LIMA`);
      if (nombres.length) setSedes(nombres);
    }).catch(() => {});
  }, []);

  const alternar = async (d) => {
    try {
      await api(`/transporte/destinos`, { method: `POST`, body: JSON.stringify({ ...d, activo: !d.activo }) });
      cargar();
    } catch (e) {
      setError(e.message);
    }
  };

  const porSede = {};
  for (const d of lista ?? []) (porSede[d.sede] ??= []).push(d);

  return (
    <section className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h3 className="text-sm font-medium text-(--text-h)">Destinos</h3>
          <p className="text-xs text-(--text)">El bot los ofrece como menú agrupado por ruta, en este orden (de menor a mayor). Cada sede tiene su lista. La ruta sirve también para agrupar pedidos.</p>
        </div>
        <button type="button" className={claseBoton} onClick={() => setEditando({})}>Nuevo destino</button>
      </div>
      <EstadoError mensaje={error} />
      {editando && !editando.id && <div className={claseTarjeta}><Fila inicial={editando} sedes={sedes} onGuardado={() => { setEditando(null); cargar(); }} onCancelar={() => setEditando(null)} /></div>}
      {lista == null ? (
        <p className="text-sm text-(--text)">Cargando…</p>
      ) : (
        Object.entries(porSede).map(([sede, destinos]) => (
          <div key={sede} className={`${claseTarjeta} flex flex-col gap-1`}>
            <p className="text-xs font-semibold text-(--text)">{sede}</p>
            <ul className="flex flex-col">
              {destinos.map((d, i) => [
                d.ruta !== destinos[i - 1]?.ruta && (
                  <li key={`r-${d.id}`} className="pt-2 text-[11px] font-medium uppercase tracking-wide text-(--accent)">{d.ruta || `Sin ruta`}</li>
                ),
                <li key={d.id} className="flex flex-wrap items-center gap-2 border-t border-(--border) py-1.5 first:border-0">
                  {editando?.id === d.id ? (
                    <Fila inicial={d} sedes={sedes} onGuardado={() => { setEditando(null); cargar(); }} onCancelar={() => setEditando(null)} />
                  ) : (
                    <>
                      <span className="w-10 text-xs text-(--text)">{d.orden}</span>
                      <span className={`flex-1 text-sm ${d.activo ? `text-(--text-h)` : `text-(--text) line-through`}`}>{d.nombre}</span>
                      <button type="button" className="text-xs text-(--accent)" onClick={() => setEditando(d)}>Editar</button>
                      <button type="button" className="text-xs text-(--text)" onClick={() => alternar(d)}>{d.activo ? `Desactivar` : `Activar`}</button>
                    </>
                  )}
                </li>,
              ])}
            </ul>
            <datalist id="rutas-destinos">{[...new Set((lista ?? []).map((x) => x.ruta).filter(Boolean))].map((x) => <option key={x} value={x} />)}</datalist>
          </div>
        ))
      )}
    </section>
  );
}
